import React, { useEffect } from 'react'
import DropdownField from 'pf9-ui-components/built/components/validatedForm/DropdownField'
import TextField from 'pf9-ui-components/built/components/validatedForm/TextField'
import VolumeTypesPicklist from 'app/plugins/openstack/components/storage/volume-types/VolumeTypesPicklist'
import ClusterVMSourceType from './ClusterVMSourceType'
import { volumeSizeValidator } from 'core/utils/fieldValidators'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import clsx from 'clsx'

interface SourcePoolFieldsProps {
  getParamsUpdater: (key: string) => (value: any) => void
  params: Record<string, any>
  className?: string
}

const SourcePoolFields = ({ params, getParamsUpdater, className }: SourcePoolFieldsProps) => {
  const classes = useStyles()

  return (
    <>
      <DropdownField
        id="clusterVmSourceType"
        DropdownComponent={ClusterVMSourceType}
        label="Boot VM From"
        onChange={(value) => getParamsUpdater('sourceType')(value)}
        value={params.sourceType}
        required
      />
      {params.sourceType === 'volume' && (
        <div className={clsx(classes.volumeSection, className)}>
          <TextField
            id="clusterVmVolumeSize"
            label="Volume Size (GiB)"
            onChange={(value) => getParamsUpdater('volumeSize')(value)}
            value={params.volumeSize}
            type="number"
            validations={[volumeSizeValidator(20)]}
            min={20}
            info="Volume size should be equivalent to virtual disk size of an image or more"
            required
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
            crossOrigin={undefined}
          />
          <DropdownField
            id="clusterVmVolumeType"
            fullWidth
            DropdownComponent={VolumeTypesPicklist}
            value={params.volumeType}
            onChange={getParamsUpdater('volumeType')}
            label="Volume Type"
            required
          />
        </div>
      )}
    </>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  volumeSection: {
    display: 'grid',
    gridGap: theme.spacing(2),
    gridTemplateColumns: '1fr',
  },
}))

export default SourcePoolFields
